import React from "react"
import BlockContent from "@sanity/block-content-to-react"
import clientConfig from "../../client-config"

const serializers = {
  types: {
    block: ({ node, children }) => {
      if (!node) return null
      return <p>{children}</p>
    },
  },
  marks: {
    externalLink: ({ mark, children }) => {
      const { href } = mark
      return (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      )
    },
  },
  container: ({ children }) => <>{children}</>,
}

const PortableText = ({ blocks }) => (
  <BlockContent blocks={blocks} serializers={serializers} {...clientConfig} />
)

export default PortableText
